import React, { useEffect, useState } from "react";
import ContactForm from "./formcontact";
import Contacts from "../../services/Contacts";
import Loader from "../../components/Loader";
const Contact = () => {
  const [contacts, setContacts] = useState(null); // Initialisez à `null`
  const [loading, setLoading] = useState(true); // Indicateur de chargement
  const contactService = new Contacts();

  useEffect(() => {
    const fetchContacts = async () => {
      try {
        const data = await contactService.getContacts(); // Récupère les contacts
        setContacts(data); // Met à jour les contacts
      } catch (error) {
        console.error("Erreur lors de la récupération des contacts :", error);
      } finally {
        setLoading(false); // Chargement terminé
      }
    };

    fetchContacts();
  }, []);
  if (loading) {
    return (
      <div className="m-5">
        <Loader height={500} width={500} />
      </div>
    );
  }

  return (
    <div className="container-fluid">
      <div className="contact-title text-center">
        <img src="assets/images/services/devenezclients.png" alt="" />
      </div>
      <div className="banner-container contact mb-4">
        <img
          src="assets/images/vecto_image_left_yellow-removebg-preview.png"
          className="img-vector"
          alt=""
        />

        <div className="banner-content row g-4 align-items-stretch">
          <div className="col-lg-6">
            <div className="hero-copy shadow-sm">
              <h3 className="hero-heading">Travaillez avec nous</h3>

              <div className="hero-text">
                <p className="hero-paragraph">
                  Vous avez un projet numérique à concrétiser ? Notre équipe
                  d’ingénieurs et de développeurs est prête à le réaliser :
                  conception de sites web, applications mobiles, solutions de
                  gestion et support technique sur mesure. Contactez-nous dès
                  aujourd’hui pour une évaluation gratuite et un devis
                  personnalisé :{" "}
                  <em>nous transformons vos idées en résultats concrets</em>.
                </p>
                <p className="hero-paragraph">
                  Visitez notre bureau ou prenez rendez-vous en ligne pour une
                  démo, réponse garantie sous 24 heures. Rejoignez de nombreux
                  clients heureux qui nous font déjà confiance et commencez
                  maintenant : notre équipe vous accompagne à chaque étape pour
                  assurer la réussite de votre projet digital.
                </p>
              </div>

              <div className="hero-illustration" aria-hidden="true">
                <img
                  src="assets/images/services/contact-illustration.png"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="row g-3 contact-card-grid">
              <div className="col-sm-6">
                <div className="card contact-card h-100">
                  <div className="contact-card-header">
                    <span className="contact-icon">
                      <i className="fas fa-map-marker-alt"></i>
                    </span>
                  </div>
                  <div className="card-body contact-card-body contact-card-body--center">
                    <p className="contact-card-label">
                      Foréké-Dschang, Cameroun
                    </p>
                    <p className="contact-card-label">Douala, Cameroun</p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6">
                <div className="card contact-card h-100">
                  <div className="contact-card-header">
                    <span className="contact-icon">
                      <i className="far fa-phone"></i>
                    </span>
                  </div>
                  <div className="card-body contact-card-body contact-card-body--center">
                    <a className="contact-card-link" href="tel:+237698613243">
                      +237 698 61 32 43
                    </a>
                    <a className="contact-card-link" href="tel:+237697049654">
                      +237 697 04 96 54
                    </a>
                    <a className="contact-card-link" href="tel:+237698765432">
                      +237 698 76 54 32
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-sm-6">
                <div className="card contact-card h-100">
                  <div className="contact-card-header">
                    <span className="contact-icon">
                      <i className="far fa-envelope"></i>
                    </span>
                  </div>
                  <div className="card-body contact-card-body contact-card-body--center contact-email-body">
                    <a
                      className="contact-email-pill"
                      href="mailto:contact@visibilitycam.com"
                    >
                      <i className="fa-regular fa-envelope"></i>
                      <span>contact@visibilitycam.com</span>
                    </a>

                    <a
                      className="contact-email-pill"
                      href="mailto:demo@visibilitycam.com"
                    >
                      <i className="fa-regular fa-envelope"></i>
                      <span>demo@visibilitycam.com</span>
                    </a>

                    <a
                      className="contact-email-pill"
                      href="mailto:support@visibilitycam.com"
                    >
                      <i className="fa-regular fa-envelope"></i>
                      <span>support@visibilitycam.com</span>
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-sm-6">
                <div className="card contact-card h-100">
                  <div className="contact-card-header">
                    <span className="contact-icon">
                      <i className="fa-regular fa-globe-pointer"></i>
                    </span>
                  </div>
                  <div className="card-body contact-card-body contact-card-body--center">
                    <div className="contact-social-list">
                      <a
                        className="contact-social-entry contact-social-entry--facebook"
                        href="https://web.facebook.com/profile.php?id=100071858223993"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <span className="entry-icon">
                          <i
                            className="fab fa-facebook-f"
                            aria-hidden="true"
                          ></i>
                        </span>
                        <div>
                          <div className="entry-label">Facebook</div>
                          <small>Actualités & événements</small>
                        </div>
                      </a>
                      <a
                        className="contact-social-entry contact-social-entry--linkedin"
                        href="https://www.linkedin.com/company/visibility-cam-sarl/"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <span className="entry-icon">
                          <i
                            className="fab fa-linkedin-in"
                            aria-hidden="true"
                          ></i>
                        </span>
                        <div>
                          <div className="entry-label">LinkedIn</div>
                          <small>Réseautage professionnel</small>
                        </div>
                      </a>
                      <a
                        className="contact-social-entry contact-social-entry--youtube"
                        href="https://youtube.com/@visibilitycam?si=Mz0_EXnJUAhHxJtZ"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <span className="entry-icon">
                          <i className="fab fa-youtube" aria-hidden="true"></i>
                        </span>
                        <div>
                          <div className="entry-label">YouTube</div>
                          <small>Découvrir nos démonstrations</small>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="col-lg-10 col-xl-9">
          <ContactForm />
        </div>
      </div>

      <div style={{ width: "100%", height: "400px" }}>
        <iframe
          title="Google Map Location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3361.602827102071!2d10.0478595!3d5.4377628!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x105fb10e4e87dc57%3A0x6c9e9dd7f92c6521!2sVisibility_Cam%20SARL!5e1!3m2!1sfr!2scm!4v1743948139977!5m2!1sfr!2scm"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
        ></iframe>
      </div>
    </div>
  );
};

export default Contact;
